<template>
<div style="margin-top: 20px; padding-top: 0" v-if="billingSummary">
    <v-toolbar flat color="white">
        <v-btn flat @click="backToSummaryList()">
            <v-icon>arrow_back</v-icon>
        </v-btn>
        <h4>Period: {{billingSummary.periodStart}} to {{billingSummary.periodEnd}}</h4>
        <v-spacer></v-spacer>
        <v-btn v-if="billingSummary.status=='Pending'" round color="light-green" style="color: white" @click="approveBilling()">Approve</v-btn>
        <v-btn round color="primary" style="color: white" @click="approveBilling()">Send to Xero</v-btn>
        <!-- {{$store.state.currentOrg.org.id}} -->
        <v-btn v-if="$store.state.currentOrg.org.id == 275" round color="light-green" style="color: white" @click="sageExport()">Sage Export</v-btn>

    </v-toolbar>
    <v-toolbar flat color="white">
        <v-tabs v-model="tab">
            <v-tab>Dashboard</v-tab>
            <v-tab>Invoices</v-tab>
            <!-- <v-tab>Customer Insight</v-tab> -->
            <v-tab>Network Insight</v-tab>
            <v-tab>Transaction Summary</v-tab>
            <!-- <v-tab>Invoices</v-tab> -->
        </v-tabs>
    </v-toolbar>
    <div v-if="tab==0">
        <v-layout mt-2 wrap justify-center align-center>
            <v-flex xs6 sm3 md3>
                <doughnutchart v-if="loaded" :chartdata="speedData" :options="speedDataOptions"></doughnutchart>
            </v-flex>
            <v-flex xs6 sm3 md3>
                <barchart v-if="loaded" :chartdata="ispSalesData" :options="ispSalesOption">
                </barchart>
            </v-flex>
            <v-flex xs6 sm6 md6>
                <v-layout wrap justify-center>
                    <v-flex xs12>
                         <v-card flat>
                    <v-card-text>
                        <v-layout wrap text-xs-left>
                            <v-flex xs6>
                                <h3 class="grey--text">Once-off sales</h3>
                            </v-flex>
                            <v-flex xs6>
                                <span class="grey--text">{{billingSummary.totalOnceOff|currency}}</span>
                            </v-flex>
                            <v-flex xs6>
                                <h3 class="grey--text">Recurring sales</h3>
                            </v-flex>
                            <v-flex xs6>
                                <span class="grey--text">{{billingSummary.totalRecurring|currency}}</span>
                            </v-flex>
                            <v-flex xs12>
                                <v-divider color="grey"></v-divider>
                            </v-flex>
                            <v-flex xs6 mt-2>
                                <h3 class="grey--text font-weight-bold">Total</h3>
                            </v-flex>
                            <v-flex xs6 mt-2>
                                <span class="grey--text font-weight-bold">{{billingSummary.totalRevenue|currency}}</span>
                            </v-flex>
                        </v-layout>
                    </v-card-text>
                </v-card>
                    </v-flex>
                    <v-flex xs12>
                         <v-card flat color="white" text-xs-left>
                             <v-card-text>

                                 <v-list>
                                     <v-list-tile>
                                         <v-list-tile-action>
                                             <v-icon>home</v-icon>
                                         </v-list-tile-action>
                                         <v-list-tile-content>
                                             <v-list-tile-title style="font-size: 14px">
                                                 Units Passed
                                             </v-list-tile-title>
                                         </v-list-tile-content>
                                         <v-list-tile-action>
                                              <v-chip class="white--text" color="light-blue"> {{billingSummary.unitsPassed}}</v-chip>
                                         </v-list-tile-action>
                                     </v-list-tile>
                                      <v-list-tile>
                                         <v-list-tile-action>
                                             <v-icon>share</v-icon>
                                         </v-list-tile-action>
                                         <v-list-tile-content>
                                             <v-list-tile-title style="font-size: 14px">
                                                 Units Connected
                                             </v-list-tile-title>
                                         </v-list-tile-content>
                                         <v-list-tile-action>
                                              <v-chip class="white--text" color="orange"> {{billingSummary.unitsConnected}}</v-chip>
                                         </v-list-tile-action>
                                     </v-list-tile>
                                      <v-list-tile>
                                         <v-list-tile-action>
                                             <v-icon>miscellaneous_services</v-icon>
                                         </v-list-tile-action>
                                         <v-list-tile-content>
                                             <v-list-tile-title style="font-size: 14px">
                                                Service Accounts
                                             </v-list-tile-title>
                                         </v-list-tile-content>
                                         <v-list-tile-action>
                                              <v-chip class="white--text" color="light-green"> {{billingSummary.unitsLive}}</v-chip>
                                         </v-list-tile-action>
                                     </v-list-tile>
                                 </v-list>
                             </v-card-text>
                   
                </v-card>
                    </v-flex>

                </v-layout>
               
               
            </v-flex>
            
            <v-flex xs10>
                <barchart v-if="loaded" :chartdata="networkData" :options="networkDataOptions">
                </barchart>
            </v-flex>
        </v-layout>
    </div>

    <div v-if="tab==1">
        <v-layout justify-center>
            <!-- <v-flex v-if="billingSummary.status=='Approved'">
            </v-flex> -->
            <v-flex>
                <v-toolbar flat color="white">
                    <v-spacer></v-spacer>
                    <v-btn color="primary" round @click="exportAllTransactions()">Export All Transactions</v-btn>
                </v-toolbar>
                <v-data-table v-if="billingSummary.status == 'Pending'" :headers="invoiceHeaders" :search="search" class="elevation-1" :items="invoices" :rows-per-page-items="[10]" item-key="id" align-center disable-initial-sort style="cursor: pointer">
                    <template v-slot:items="props">
                        <td class="text-xs-center">
                            <v-layout justify-center>
                                <v-icon @click="item=props.item, invoiceModal=true">launch</v-icon>
                                <v-icon @click="exportCustomerTransactions(props.item.customerOrganisationId)">download</v-icon>
                                <v-icon @click="exportCustomerChanges(props.item.customerOrganisationId)">refresh</v-icon>

                            </v-layout>
                        </td>

                        <td class="text-xs-left">{{props.item.customerOrganisation.name}}</td>
                        <td class="text-xs-center">
                            <v-icon v-if="props.item.xeroContactId" color="light-green">check_circle</v-icon>
                            <v-icon color="red" v-else>cancel</v-icon>
                        </td>
                        <td class="text-xs-center">{{props.item.dueDate}}</td>
                        <td class="text-xs-center">
                            <v-chip>{{props.item.accountsBilled}}</v-chip>
                        </td>
                        <td class="text-xs-center">
                            <v-chip>{{props.item.invoiceLineItems.length}}</v-chip>
                        </td>
                        <td class="text-xs-center">{{props.item.subTotal | currency}}</td>
                        <td class="text-xs-center">{{props.item.totalTax | currency}}</td>
                        <td class="text-xs-center">{{props.item.total | currency}}</td>
                    </template>
                    <template v-slot:pageText="props">Records {{ props.pageStart }} - {{ props.pageStop }} of {{ props.itemsLength }}</template>
                </v-data-table>
                <v-data-table v-else-if="billingSummary.status == 'Approved'" :headers="invoiceExistHeaders" :search="search" class="elevation-1" :items="invoices" :rows-per-page-items="[10]" item-key="id" align-center disable-initial-sort style="cursor: pointer">
                    <template v-slot:items="props">
                        <td class="text-xs-center">
                            <v-layout justify-center>
                                <v-icon @click="item=props.item, invoiceModal=true">launch</v-icon>
                                <v-icon @click="exportCustomerTransactions(props.item.customerOrganisationId)">download</v-icon>
                                <v-icon @click="exportCustomerChanges(props.item.customerOrganisationId)">refresh</v-icon>

                                
                            </v-layout>
                        </td>
                      <td class="text-xs-center">{{props.item.status}}</td>
                      <td class="text-xs-center">{{props.item.invoiceNumber}}</td>
                        <td class="text-xs-center">{{props.item.customerOrganisation.name}}</td>
                        <td class="text-xs-center">{{formatDate(props.item.dueDate)}}</td>
                        <td class="text-xs-center">{{props.item.subTotal | currency}}</td>
                        <td class="text-xs-center">{{props.item.totalTax | currency}}</td>
                        <td class="text-xs-center">{{props.item.total | currency}}</td>
                        <td class="text-xs-center">{{props.item.amountDue | currency}}</td>
                    </template>
                    <template v-slot:pageText="props">Records {{ props.pageStart }} - {{ props.pageStop }} of {{ props.itemsLength }}</template>
                </v-data-table>
            </v-flex>
        </v-layout>
    </div>

     <!-- <div v-if="tab==2">
          <v-layout justify-center>
            <v-flex>
                <v-data-table :headers="customerInsightHeaders" :search="search" class="elevation-1" :items="ispStatistics" :rows-per-page-items="[10, 25, 50]" item-key="id" align-center disable-initial-sort style="cursor: pointer">
                    <template v-slot:items="props">
                          <td class="text-xs-center">
                           <v-btn icon @click="selectedStatistics = props.item, ispStatisticsModal = true"><v-icon>launch</v-icon></v-btn>
                        </td>
                        <td class="text-xs-center">
                            {{props.item.isp}}
                        </td>
                         <td class="text-xs-center">
                            <v-chip>{{props.item.full}}</v-chip>
                        </td>
                         <td class="text-xs-center">
                            <v-chip>{{props.item.partial}}</v-chip>
                        </td>
                        <td class="text-xs-center">
                            <v-chip small color='blue' class="white--text font-weight-bold" v-if="props.item.newConnections>0">{{props.item.newConnections}}</v-chip>
                        </td>
                        <td class="text-xs-center">
                             <v-chip small color='green' class="white--text font-weight-bold" v-if="props.item.upgrades>0">{{props.item.upgrades}}</v-chip>
                        </td>
                        <td class="text-xs-center">
                             <v-chip small color='orange' class="white--text font-weight-bold" v-if="props.item.downgrades>0">{{props.item.downgrades}}</v-chip>
                        </td>
                        <td class="text-xs-center">
                            <v-chip small color='red' class="white--text font-weight-bold" v-if="props.item.terminations>0"> {{props.item.terminations}}</v-chip>
                        </td>
                    </template>
                </v-data-table>
            </v-flex>
          </v-layout>
     </div> -->

    <div v-if="tab==2">
        <v-layout justify-center>
            <v-flex>
                <v-toolbar flat color="white">
                    <v-spacer></v-spacer>
                    <v-btn @click="networkReportModal = true" color="primary" round><v-icon>summarize</v-icon>Investor Export</v-btn>
                </v-toolbar>
                <v-data-table :headers="networkHeaders" :search="search" class="elevation-1" :items="networkTransactions" :rows-per-page-items="[10, 25, 50]" item-key="id" align-center disable-initial-sort style="cursor: pointer">
                    <template v-slot:items="props">
                        <td class="text-xs-center">
                            <v-layout justify-center>
                                <v-icon @click="exportNetworkTransactions(props.item.id)">download</v-icon>
                            </v-layout>
                        </td>
                        <td class="text-xs-center">
                            {{props.item.name}}
                        </td>
                        <td class="text-xs-center">
                            <span v-if="props.item.investor.length>0">
                                {{props.item.investor.map(x=>x.customerOrganisation.name).join(' - ')}}
                            </span>
                        </td>
                        <td class="text-xs-center">
                            <v-chip>{{props.item.accounts}}</v-chip>
                        </td>
                        <td class="text-xs-center">
                            <span v-if="props.item.newAccounts"> + {{props.item.newAccounts}}</span>
                        </td>
                        <td class="text-xs-center">
                            {{props.item.arpu | currency}}
                        </td>
                        <td class="text-xs-center">
                            {{props.item.lastMonthArpu | currency}} <br>
                            <div v-if="props.item.lastMonthArpu">
                                <span v-if="CalculatePercentage(props.item.arpu, props.item.lastMonthArpu)>0" style="fontSize: 12px; color: green">{{'+'+CalculatePercentage(props.item.arpu, props.item.lastMonthArpu)+'%'}}</span>
                                <span v-else style="fontSize: 12px;color: red">{{CalculatePercentage(props.item.arpu, props.item.lastMonthArpu)+'%'}}</span>
                            </div>

                        </td>

                        <td class="text-xs-center">
                            {{props.item.onceOffSales | currency}}
                        </td>
                        <td class="text-xs-center">
                            {{props.item.recurringSales | currency}}
                        </td>
                        <td class="text-xs-center">
                            <span v-if="props.item.lastMonthRecurringSales>0">
                                {{props.item.lastMonthRecurringSales | currency}} <br>
                                <span v-if="CalculatePercentage(props.item.recurringSales, props.item.lastMonthRecurringSales)>0" style="fontSize: 12px; color: green">{{'+'+CalculatePercentage(props.item.recurringSales, props.item.lastMonthRecurringSales)+'%'}}</span>
                                <span v-else style="fontSize: 12px;color: red">{{CalculatePercentage(props.item.recurringSales, props.item.lastMonthRecurringSales)+'%'}}</span>

                            </span>
                        </td>
                        <td class="text-xs-center">
                            <span v-if="props.item.threeMonthRecurringSales>0">
                                {{props.item.threeMonthRecurringSales | currency}}<br>
                                <span v-if="CalculatePercentage(props.item.recurringSales, props.item.threeMonthRecurringSales)>0" style="fontSize: 12px; color: green">{{'+'+CalculatePercentage(props.item.recurringSales, props.item.threeMonthRecurringSales)+'%'}}</span>
                                <span v-else style="fontSize: 12px;color: red">{{CalculatePercentage(props.item.recurringSales, props.item.threeMonthRecurringSales)+'%'}}</span>
                            </span>
                        </td>
                        <td class="text-xs-center">
                            <span v-if="props.item.sixMonthRecurringSales>0">
                                {{props.item.sixMonthRecurringSales | currency}}<br>
                                <span v-if="CalculatePercentage(props.item.recurringSales, props.item.sixMonthRecurringSales)>0" style="fontSize: 12px; color: green">{{'+'+CalculatePercentage(props.item.recurringSales, props.item.sixMonthRecurringSales)+'%'}}</span>
                                <span v-else style="fontSize: 12px;color: red">{{CalculatePercentage(props.item.recurringSales, props.item.sixMonthRecurringSales)+'%'}}</span>

                            </span>
                        </td>
                        <td class="text-xs-center">
                            <span v-if="props.item.twelveMonthRecurringSales>0">
                                {{props.item.twelveMonthRecurringSales | currency}}<br>
                                <span v-if="CalculatePercentage(props.item.recurringSales, props.item.twelveMonthRecurringSales)>0" style="fontSize: 12px; color: green">{{CalculatePercentage(props.item.recurringSales, props.item.twelveMonthRecurringSales)+'%'}}</span>
                                <span v-else style="fontSize: 12px;color: red">{{CalculatePercentage(props.item.recurringSales, props.item.twelveMonthRecurringSales)+'%'}}</span>
                            </span>
                        </td>

                    </template>
                </v-data-table>
            </v-flex>
        </v-layout>
    </div>

    <div v-if="tab==3">
        <v-layout justify-start wrap>
            <v-toolbar flat color="white">
                <v-text-field label="Search" v-model="searchTransactionSummary" clearable></v-text-field>

                <v-spacer></v-spacer>
                <v-btn color="primary" round @click="exportAllTransactions()">Export All Transactions</v-btn>
            </v-toolbar>
            <v-flex xs12>
                <v-data-table :headers="transactionSummaryHeaders" :search="searchTransactionSummary" class="elevation-1" :items="transactionSummary" :rows-per-page-items="[10, 25, 50]" item-key="id" align-center disable-initial-sort style="cursor: pointer">
                    <template v-slot:items="props">
                        <td class="text-xs-center">
                            <v-icon @click="viewTransactionSummary(props.item)">launch</v-icon>
                        </td>
                        <td class="text-xs-center">
                            {{props.item.name}}
                        </td>
                        <td class="text-xs-center">
                            <span v-if="props.item.customerTotal> 0" style="color: green">
                                {{props.item.customerTotal | currency}}
                            </span>
                        </td>
                        <td class="text-xs-center">
                            <span v-if="props.item.supplierTotal> 0" style="color: red">
                                {{props.item.supplierTotal | currency}}
                            </span>
                        </td>
                    </template>
                </v-data-table>
            </v-flex>
        </v-layout>
    </div>

    <v-dialog v-model="invoiceModal" width="750px" persistent>
        <v-card v-if="item">
            <v-toolbar flat color="primary">
                <v-toolbar-title style="color: white" v-if="item&&item.customerOrganisation">
                    {{item.customerOrganisation.name}}: {{billingSummary.periodStart}} to {{billingSummary.periodEnd}}
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn flat @click="invoiceModal=false, item={}" color="white">X</v-btn>
            </v-toolbar>
            <v-card-text>
                <v-layout justify-end wrap>
                    <v-flex xs3 class="text-xs-left">
                        <h4>Total: </h4>
                        <h4>Subtotal: </h4>
                        <h4>VAT: </h4>

                    </v-flex>
                    <v-flex xs4 class="text-xs-right">
                        <b>{{item.total | currency}}</b><br>
                        <span>{{item.subTotal | currency}}</span><br>
                        <span>{{item.totalTax | currency}}</span>

                    </v-flex>
                    <v-flex xs12>
                        <v-data-table :headers="lineItemHeaders" :items="item.invoiceLineItems">
                            <template v-slot:items="props">
                                <td class="text-xs-center">
                                    {{props.item.description}}
                                </td>
                                <td class="text-xs-center">
                                    {{props.item.quantity}}
                                </td>
                                <td class="text-xs-center">
                                    {{props.item.amount | currency}}
                                </td>
                                 <td class="text-xs-center">
                                    {{props.item.subTotal | currency}}
                                </td>
                                <td class="text-xs-center">
                                    {{props.item.total | currency}}
                                </td>
                                <!-- <td class="text-xs-center">
                                    {{(props.item.total - props.item.amount) | currency}}
                                </td>

                                <td class="text-xs-center">
                                    {{props.item.total | currency}}
                                </td> -->
                            </template>

                        </v-data-table>
                    </v-flex>
                </v-layout>
            </v-card-text>
        </v-card>
    </v-dialog>

    <v-dialog v-model="approveBillingModal" width="1200px" persistent>
        <v-card v-if="billingItem">
            <v-toolbar flat color="primary">
                <v-toolbar-title style="color: white">
                    {{billingSummary.periodStart}} to {{billingSummary.periodEnd}}
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn flat color="white" @click="submitBilling()" v-if="billingItem.createInvoice&&!loadingInvoices">Submit</v-btn>
                <v-progress-circular v-if="loadingInvoices" size="20" indeterminate color="white"></v-progress-circular>
                <v-btn flat color="white" @click="approveTransactions()" v-else>Only Approve Transactions</v-btn>

                <v-btn flat @click="approveBillingModal=false, billingItem={}" color="white">X</v-btn>
            </v-toolbar>
            <v-card-text>
                <v-layout justify-center wrap>
                    <!-- <v-flex xs3 class="mx-2">
                        <v-checkbox v-model="billingItem.createInvoice" label="Create Invoices"></v-checkbox>
                    </v-flex> -->
                    <v-flex xs3 class="mx-2">
                        <v-select v-model="billingItem.status" label="Invoice Status" :items="invoiceStatuses"></v-select>
                    </v-flex>
                    <v-flex xs3 class="mx-2">
                        <v-checkbox v-model="billingItem.sendEmail" label="Email Invoice"></v-checkbox>
                    </v-flex>
                    
                    <v-flex xs3 class="mx-2">
                        <v-text-field label="Reference" v-model="billingItem.reference"></v-text-field>
                    </v-flex>
                    <v-flex xs12>
                        <span>The Following invoices will be created: </span>
                    </v-flex>
                    <v-flex>
                        <v-data-table :headers="invoiceHeaders" :search="search" class="elevation-1" :items="invoices.filter(x=>x.xeroContactId)" :rows-per-page-items="[10]" item-key="id" align-center disable-initial-sort style="cursor: pointer">
                            <template v-slot:items="props">
                                <td class="text-xs-center">
                                    <!-- <v-layout justify-center>
                                        <v-icon @click="item=props.item, invoiceModal=true">launch</v-icon>
                                        <download-excel :data="props.item.accounts" worksheet="export" :name="'Billing_'+new Date().getTime()+'.xls'">
                                            <v-icon>download</v-icon>
                                        </download-excel>
                                    </v-layout> -->

                                </td>

                                <td class="text-xs-left">{{props.item.customerOrganisation.name}}</td>
                                <td class="text-xs-center">
                                    <v-icon v-if="props.item.xeroContactId" color="light-green">check_circle</v-icon>
                                    <v-icon color="red" v-else>cancel</v-icon>
                                </td>
                                <td class="text-xs-center">{{props.item.dueDate}}</td>
                                <td class="text-xs-center">
                                    <v-chip>{{props.item.accountsBilled}}</v-chip>
                                </td>
                                <td class="text-xs-center">
                                    <v-chip>{{props.item.invoiceLineItems.length}}</v-chip>
                                </td>
                                <td class="text-xs-center">{{props.item.subTotal | currency}}</td>
                                <td class="text-xs-center">{{props.item.totalTax | currency}}</td>
                                <td class="text-xs-center">{{props.item.total | currency}}</td>

                            </template>
                            <template v-slot:pageText="props">Records {{ props.pageStart }} - {{ props.pageStop }} of {{ props.itemsLength }}</template>
                        </v-data-table>
                    </v-flex>
                </v-layout>
            </v-card-text>
        </v-card>
    </v-dialog>

    <v-dialog v-model="invoiceSuccessModal" persistent width="750px">
        <v-card color="white" flat>
            <v-toolbar flat color="light-green">
                <h3 class="title white--text">
                    Successfully created the following invoices:
                </h3>
            </v-toolbar>
            <v-card-text ma-1>
                <v-layout justify-center align-center wrap>
                    <v-flex xs8 mx-1 v-for="invoice in successfulInvoices" :key="invoice.invoiceID">
                        <v-layout justify-center align-center>
                            <v-flex xs3 mx-1>
                                <h3 class="grey--text font-weight-light">{{invoice.invoiceNumber}}</h3>
                            </v-flex>
                            <v-flex xs3 mx-1>
                                <h3 class="grey--text font-weight-light">{{invoice.contact.name}}</h3>
                            </v-flex>
                            <v-flex xs3 mx-1>
                                <h3 class="grey--text font-weight-light">{{invoice.total | currency}}</h3>
                            </v-flex>
                            <v-flex xs3 mx-1>
                                <v-chip v-if="invoice.status == 'DRAFT'" color="blue" class="white--text">DRAFT</v-chip>
                                <v-chip v-else color="light-green" class="white--text">{{invoice.status}}</v-chip>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-layout>
                <v-card-actions>
                    <v-layout justify-center>
                        <v-btn round color="light-green" class="white--text" @click="invoiceSuccessModal=false, successfulInvoices=[]">Done</v-btn>
                    </v-layout>
                </v-card-actions>
            </v-card-text>
        </v-card>
    </v-dialog>

    <!-- ISP Statistics Modal -->
    <v-dialog v-model="ispStatisticsModal" width="800px" persistent>
        <v-card v-if="selectedStatistics">
            <v-toolbar flat color="white">
                <v-toolbar-title>{{selectedStatistics.isp}}</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn flat @click="ispStatisticsModal=false">X</v-btn>
            </v-toolbar>
            <v-card-text>
                <v-data-table :headers="statisticsHeaders" :items="selectedStatistics.data"  :rows-per-page-items="[10]">
                     <template v-slot:items="props">
                                <td class="text-xs-center">
                                    {{props.item.speed}}Mbps
                                </td>
                                 <td class="text-xs-center">
                                    {{props.item.count}}
                                </td>
                                 <td class="text-xs-center">
                                    {{props.item.full}}
                                </td>
                                 <td class="text-xs-center">
                                    {{props.item.partial}}
                                </td>
                                 <td class="text-xs-center">
                                    {{props.item.newActivations}}
                                </td>
                     </template>
                </v-data-table>
            </v-card-text>
        </v-card>
    </v-dialog>
    <!-- TransactionSummary Modal -->
    <v-dialog v-model="transactionSummaryModal" width="750px">
        <v-card v-if="selectedTransactionSummary">
            <v-toolbar flat color="primary">
                <v-toolbar-title style="color: white">{{selectedTransactionSummary.name}}</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn flat color="white" @click="selectedTransactionSummary={}, transactionSummaryModal=false">X</v-btn>
            </v-toolbar>
            <v-tabs v-model="transactionSummaryTab">
                <v-tab>
                    Sales
                </v-tab>
                <v-tab>
                    Cost of Sales
                </v-tab>
            </v-tabs>
            <v-card-text>
                <div v-if="transactionSummaryTab==1&&selectedTransactionSummary">
                    <v-layout wrap>
                        <v-flex xs12>
                            <v-layout>
                                <v-flex class="mx-1">
                                    <v-select clearable label="Description" v-model="filteredSupplierDescription" :items="transactionDescriptions(selectedTransactionSummary.supplierTransactions)"></v-select>
                                </v-flex>
                                <v-flex class="mx-1">
                                    <v-select clearable label="Networks" v-model="filteredSupplierNetwork" :items="transactionNetworks(selectedTransactionSummary.supplierTransactions)"></v-select>
                                </v-flex>
                                <v-flex class="mx-1">
                                    <v-select clearable label="Nodes" v-model="filteredSupplierNode" :items="transactionNodes(selectedTransactionSummary.supplierTransactions)"></v-select>
                                </v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex xs12>
                            <v-spacer></v-spacer>
                            <v-btn round color="primary" class="white--text" @click="exportSupplierSummaryTransactions(selectedTransactionSummary.id)">Export All COS Transactions</v-btn>
                        </v-flex>
                    </v-layout>

                    <v-data-table :headers="selectedSummaryHeaders" :items="filteredSupplierTransactions">
                        <template v-slot:items="props">
                            <td class="text-xs-center">
                                <span v-if="props.item.locationNetwork">{{props.item.locationNetwork.name}}</span>
                            </td>
                            <td class="text-xs-center">
                                <span v-if="props.item.locationNode">{{props.item.locationNode.name}}</span>
                            </td>
                            <td class="text-xs-center">
                                {{props.item.description}}
                            </td>
                            <td class="text-xs-center">
                                {{props.item.amount | currency}}
                            </td>
                        </template>
                    </v-data-table>
                </div>
                <div v-if="transactionSummaryTab==0&&selectedTransactionSummary">
                    <v-layout wrap>
                        <v-flex xs12>
                            <v-layout>
                                <v-flex class="mx-1">
                                    <v-select clearable label="Description" v-model="filteredCustomerDescription" :items="transactionDescriptions(selectedTransactionSummary.customerTransactions)"></v-select>
                                </v-flex>
                                <v-flex class="mx-1">
                                    <v-select clearable label="Networks" v-model="filteredCustomerNetwork" :items="transactionNetworks(selectedTransactionSummary.customerTransactions)"></v-select>
                                </v-flex>
                                <v-flex class="mx-1">
                                    <v-select clearable label="Nodes" v-model="filteredCustomerNode" :items="transactionNodes(selectedTransactionSummary.customerTransactions)"></v-select>
                                </v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex xs12>
                            <v-spacer></v-spacer>
                            <v-btn round color="primary" class="white--text" @click="exportCustomerSummaryTransactions(selectedTransactionSummary.id)">Export All Sales Transactions</v-btn>
                        </v-flex>
                    </v-layout>

                    <v-data-table :headers="selectedSummaryHeaders" :items="filteredCustomerTransactions">
                        <template v-slot:items="props">
                            <td class="text-xs-center">
                                <span v-if="props.item.locationNetwork">{{props.item.locationNetwork.name}}</span>
                            </td>
                            <td class="text-xs-center">
                                <span v-if="props.item.locationNode">{{props.item.locationNode.name}}</span>
                            </td>
                            <td class="text-xs-center">
                                {{props.item.description}}
                            </td>
                            <td class="text-xs-center">
                                {{props.item.amount | currency}}
                            </td>
                        </template>
                    </v-data-table>
                </div>
            </v-card-text>
        </v-card>
    </v-dialog>

    <v-dialog v-model="networkReportModal" width="750px">
    <v-card>
        <v-toolbar flat color="primary">
                <v-toolbar-title style="color: white">Export Investor Report</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn flat color="white" @click="networkReportModal=false">X</v-btn>
            </v-toolbar>
            <v-card-text>
                <v-list three-line>
                    <v-list-tile v-for="investor in investors" :key="investor.id">
                    <v-list-tile-content>
                        <v-list-tile-title style="font-weight: bold">
                            {{investor.name}}
                        </v-list-tile-title>
                        <v-list-tile-subtitle style="font-size: 12px; color: grey">
                            {{investor.networks.length}} Network(s)
                        </v-list-tile-subtitle>
                        <v-list-tile-subtitle style="font-size: 12px; color: grey">
                           <b>Recurring Sales:</b> {{investor.recurringSales | currency}}
                        </v-list-tile-subtitle>
                    </v-list-tile-content>
                    <v-list-tile-action>
                        <v-btn icon :loading="investor.loading" @click="downloadInvestorReport(investor)"><v-icon>download</v-icon></v-btn>
                    </v-list-tile-action>
                    </v-list-tile>
                </v-list>
            </v-card-text>
    </v-card>
    </v-dialog>
</div>
</template>

<script>
import Api from "@/services/Api";
import BarChart from "./BarChart.vue";
import PieChart from "./PieChart.vue";
import LineChart from "./LineChart.vue";
import dateformat from "dateformat";
import DoughnutChart from "./DoughnutChart.vue";
import SystemInvoices from '../components/SystemInvoices.vue'
export default {
    components: {
        barchart: BarChart,
        piechart: PieChart,
        linechart: LineChart,
        doughnutchart: DoughnutChart,
        systeminvoices: SystemInvoices
    },
    data() {
        return {
            approveBillingModal: false,
            billingBreakdown: [],
            billingSummary: {},
            filterIsp: null,
            filterNetwork: null,
            filterFnoPackage: null,
            fnoPackageList: [],
            loaded: false,
            tab: 0,
            invoiceModal: false,
            item: {},
            menu: false,
            networkTransactions: [],
            invoices: [],
            invoiceStatuses: ['DRAFT', 'SUBMITTED', 'AUTHORISED'],
            ispStatistics: [],
            ispStatisticsModal: false,
            selectedStatistics: {},
            loadingInvoices: false,
            lineAmountTypes: ['Exclusive', 'Inclusive', 'NoTax'],
            lineItemHeaders: [{
                    text: "Description",
                    align: "center",
                    value: "description"
                },
                {
                    text: "Quantity",
                    align: "center",
                    value: "quantity"
                },
                {
                    text: "Unit Amount",
                    align: "center",
                    value: "amount"
                },
                {
                    text: "Subtotal",
                    align: "center",
                    value: "subTotal"
                },
                {
                    text: "Total",
                    align: "center",
                    value: "total"
                },
            ],
            statisticsHeaders: [
                {
                    text: "Download Speed",
                    align: "center",
                    value: "speed"
                },
                 {
                    text: "Total Accounts",
                    align: "center",
                    value: "count"
                },
                {
                    text: "Full Accounts",
                    align: "center",
                    value: "full"
                },
                {
                    text: "Partial Accounts",
                    align: "center",
                    value: "partial"
                },
                {
                    text: "New Accounts",
                    align: "center",
                    value: "newActivations"
                },
            ],
            customerInsightHeaders: [
                {
                    text: "Action",
                    align: "center",
                    value: "action"
                },
                {
                    text: "ISP",
                    align: "center",
                    value: "isp"
                },
                {
                    text: "Full Accounts",
                    align: "center",
                    value: "full"
                },
                {
                    text: "Partial Accounts",
                    align: "center",
                    value: "partial"
                },
                {
                    text: "New Accounts",
                    align: "center",
                    value: "newConnections"
                },
                {
                    text: "Upgrades",
                    align: "center",
                    value: "upgrades"
                },
                {
                    text: "Downgrades",
                    align: "center",
                    value: "downgrades"
                },
                {
                    text: "Terminations",
                    align: "center",
                    value: "terminations"
                }
                ],
            networkHeaders: [{
                text: 'Action',
                align: 'center',
                value: 'action'
            },{
                    text: "Network",
                    align: "center",
                    value: "name"
                },
                {
                    text: "Investor",
                    align: "center",
                    value: "investor"
                },
                {
                    text: "Accounts",
                    align: "center",
                    value: "accounts"
                },
                {
                    text: "New Accounts",
                    align: "center",
                    value: "newAccounts"
                },
                {
                    text: "ARPU",
                    align: "center",
                    value: "arpu"
                },
                {
                    text: "Previous ARPU",
                    align: "center",
                    value: "lastMonthArpu"
                },
                {
                    text: "Once-off Sales",
                    align: "center",
                    value: "onceOffSales"
                },
                {
                    text: "Recurring Sales",
                    align: "center",
                    value: "recurringSales"
                },
                {
                    text: "Previous Month",
                    align: "center",
                    value: "lastMonthRecurringSales"
                },
                {
                    text: "3 Months",
                    align: "center",
                    value: "threeMonthRecurringSales"
                },
                {
                    text: "6 Months",
                    align: "center",
                    value: "sixMonthRecurringSales"
                },
                {
                    text: "12 Months",
                    align: "center",
                    value: "twelveMonthRecurringSales"
                }
            ],
            invoiceExistHeaders: [
                {
                    text: "Actions",
                    align: "center",
                    value: "actions",
                    sortable: false
                },
                {
                    text: "Status",
                    align: "center",
                    value: "status"
                },
                {
                    text: "Invoice No.",
                    align: "center",
                    value: "invoiceNumber"
                },
                {
                    text: "Customer",
                    align: "center",
                    value: "name"
                },
                {
                    text: "Due Date",
                    align: "center",
                    value: "dueDate"
                },
                // {
                //     text: "Accounts Billed",
                //     align: "center",
                //     value: "accounts.length"
                // },
                // {
                //     text: "Line Items",
                //     align: "center",
                //     value: "lineItems.length"
                // },
                {
                    text: "Total Excl VAT",
                    align: "center",
                    value: "subTotal"
                },
                {
                    text: "VAT",
                    align: "center",
                    value: "tax"
                },
                {
                    text: "Total",
                    align: "center",
                    value: "total"
                },
                {
                    text: "Amount Owing",
                    align: "center",
                    value: "amountDue"
                },
            ],
            invoiceHeaders: [{
                    text: "Actions",
                    align: "center",
                    value: "actions",
                    sortable: false
                },
                {
                    text: "ISP",
                    align: "center",
                    value: "name"
                },
                {
                    text: "Account Linked",
                    align: "center",
                    value: "accountingId"
                },
                {
                    text: "Due Date",
                    align: "center",
                    value: "dueDate"
                },
                {
                    text: "Accounts Billed",
                    align: "center",
                    value: "accounts.length"
                },
                {
                    text: "Line Items",
                    align: "center",
                    value: "lineItems.length"
                },
                {
                    text: "Total Excl VAT",
                    align: "center",
                    value: "subTotal"
                },
                {
                    text: "VAT",
                    align: "center",
                    value: "tax"
                },
                {
                    text: "Total",
                    align: "center",
                    value: "total"
                },
            ],
            headers: [{
                    text: "Circuit Number",
                    align: "center",
                    value: "circuitNumber"
                },
                {
                    text: "ISP",
                    align: "center",
                    value: "isp"
                },
                {
                    text: "Node",
                    align: "center",
                    value: "node"
                },
                {
                    text: "Network",
                    align: "center",
                    value: "network"
                },
                {
                    text: "Unit",
                    align: "center",
                    value: "unit"
                },
                {
                    text: "FNO Package",
                    align: "center",
                    value: "fnoPackage"
                },
                {
                    text: "Billing Start",
                    align: "center",
                    value: "billedFrom"
                },
                {
                    text: "Billing End",
                    align: "center",
                    value: "billedTo"
                },
                {
                    text: "Once-Off Fee",
                    align: "center",
                    value: 'onceOffFee'
                },
                {
                    text: "Package Fee",
                    align: "center",
                    value: 'packageFee'
                }
            ],
            transactionSummaryHeaders: [{
                text: "Actions",
                align: "center",
                value: 'action',
                sortable: false
            }, {
                text: "Organisation",
                align: "center",
                value: 'name'
            }, {
                text: "Sales",
                align: "center",
                value: 'customerTotal'
            }, {
                text: "Cost of Sales",
                align: "center",
                value: 'supplierTotal'
            }],
            selectedSummaryHeaders: [{
                    text: "Network",
                    align: "center",
                    value: 'locationNetwork.name'
                },
                {
                    text: "Node",
                    align: "center",
                    value: 'locationNode.name'
                },
                {
                    text: "Description",
                    align: "center",
                    value: 'description'
                },
                {
                    text: "Amount",
                    align: "center",
                    value: 'amount'
                }
            ],
            networkReportModal: false,
            filteredCustomerDescription: null,
            filteredCustomerNetwork: null,
            filteredCustomerNode: null,
            filteredSupplierDescription: null,
            filteredSupplierNetwork: null,
            filteredSupplierNode: null,
            billingSettings: {},
            ispList: [],
            loadingInvoiceData: false,
            networkList: [],
            search: '',
            ispSalesData: {},
            ispSalesOptions: {},
            networkData: {},
            networkDataOptions: {},
            speedData: {},
            speedDataOptions: {},
            accountingAccounts: [],
            accountingItems: [],
            accountingContacts: [],
            connectedOrgs: [],
            invoiceData: [],
            packagesFno: [],
            taxTypes: [],
            invoiceSuccessModal: false,
            searchTransactionSummary: '',
            sendingInvoices: false,
            successfulInvoices: [],
            transactionSummary: [],
            selectedTransactionSummary: {},
            transactionSummaryModal: false,
            transactionSummaryTab: 0
        }
    },
    watch: {
        // 'billingItem.dueDate':{
        //   immediate: true,
        //   handler(value){
        //     console.log(value)
        //     if(value){
        //       this.invoiceData.map(x=>{
        //         if(x.linkDate){
        //           x.dueDate = value
        //         }
        //         return x
        //       })
        //       // for(let i=0;i<data.length;i++){
        //       //   data[i].dueDate = value
        //       // }
        //       console.log(this.invoiceData)
        //     }
        //   }
        // }
    },
    created() {
        this.load()
    },
    computed: {
        filteredTransactions() {
            let result = this.billingBreakdown ? this.billingBreakdown : []
            if (this.filterIsp) {
                result = result.filter(x => x.isp == this.filterIsp)
            }
            if (this.filterNetwork) {
                result = result.filter(x => x.network == this.filterNetwork)
            }
            if (this.filterFnoPackage) {
                result = result.filter(x => x.fnoPackage == this.filterFnoPackage)
            }
            return result
        },
        filteredCustomerTransactions() {
            let result = this.selectedTransactionSummary && this.selectedTransactionSummary.customerTransactions && this.selectedTransactionSummary.customerTransactions.length > 0 ? this.selectedTransactionSummary.customerTransactions : []
            if (this.filteredCustomerDescription) {
                result = result.filter(x => x.description == this.filteredCustomerDescription)
            }

            if (this.filteredCustomerNetwork) {
                result = result.filter(x => x.locationNetwork && x.locationNetwork.name == this.filteredCustomerNetwork)
            }

            if (this.filteredCustomerNode) {
                result = result.filter(x => x.locationNode && x.locationNode.name == this.filteredCustomerNode)
            }
            return result
        },
        filteredSupplierTransactions() {
            let result = this.selectedTransactionSummary && this.selectedTransactionSummary.supplierTransactions && this.selectedTransactionSummary.supplierTransactions.length > 0 ? this.selectedTransactionSummary.supplierTransactions : []
            if (this.filteredSupplierDescription) {
                result = result.filter(x => x.description == this.filteredSupplierDescription)
            }

            if (this.filteredSupplierNetwork) {
                result = result.filter(x => x.locationNetwork && x.locationNetwork.name == this.filteredSupplierNetwork)
            }

            if (this.filteredSupplierNode) {
                result = result.filter(x => x.locationNode && x.locationNode.name == this.filteredSupplierNode)
            }
            return result
        },
        CalculatedTotalSales() {
            let result = this.filteredTransactions
            return result.reduce((a, b) => +a + +b.packageFee, 0) + result.reduce((a, b) => +a + +b.onceOffFee, 0)
        },
        CalculatedConnections() {
            let result = this.filteredTransactions.length
            return result
        },
        investors(){
            let orgs = this.networkTransactions.filter(x=>x.investor.length>0)
            let allOrgs = [].concat.apply([], orgs.map(x=>x.investor))
            orgs = [... new Set(allOrgs.map(x=>x.customerOrganisationId))]
            let result = []
            for(let i=0;i<orgs.length;i++){
                let find = allOrgs.find(x=>x.customerOrganisationId == orgs[i])
                let networks = this.networkTransactions.filter(x=>x.investor.some(y=>y.customerOrganisationId == orgs[i]))
                let obj = {
                    id: find.customerOrganisationId,
                    name: find.customerOrganisation.name,
                    networks: networks,
                    accounts: networks.reduce((a,b)=> a+b.accounts, 0),
                    newAccounts: networks.reduce((a,b)=> a+b.newAccounts, 0),
                    recurringSales: networks.reduce((a,b)=> a+b.recurringSales, 0),
                    onceOffSales: networks.reduce((a,b)=> a+b.onceOffSales, 0)
                }
                result.push(obj)
            }
            console.log(result)
            return result
        }
    },
    methods: {
        load() {
            this.loadingInvoiceData = true
            this.getBillingSummary(this.$route.params.id)
            this.getNetworkInsights(this.$route.params.id)
            this.getInvoiceData(this.$route.params.id)
            this.getIspStatistics(this.$route.params.id)
            // this.fetchConnectedOrganisations()
        },
        exportNetworkTransactions(networkId){
            Api()
                .get("/transactions/export/network/" + networkId + '/' + this.billingSummary.id).then(response => {
                    var hiddenElement = document.createElement('a');
                    hiddenElement.href="data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,"+response.data;
                    hiddenElement.target = '_blank';
                    hiddenElement.download = this.billingSummary.periodEnd + '_sales_transactions.xls';
                    hiddenElement.click();
                })
        },
        exportCustomerSummaryTransactions(orgId) {
            Api()
                .get("/transactions/export/customer/" + orgId + '/' + this.billingSummary.batchNumber).then(response => {
                    var hiddenElement = document.createElement('a');
                    hiddenElement.href="data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,"+response.data;
                    hiddenElement.target = '_blank';
                    hiddenElement.download = this.billingSummary.periodEnd + '_sales_transactions.xls';
                    hiddenElement.click();
                })
        },
        exportSupplierSummaryTransactions(orgId) {
            Api()
                .get("/transactions/export/supplier/" + orgId + '/' + this.billingSummary.batchNumber).then(response => {
                    var hiddenElement = document.createElement('a');
                    hiddenElement.href="data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,"+response.data;
                    hiddenElement.target = '_blank';
                    hiddenElement.download = this.billingSummary.periodEnd + '_transactions.xls';
                    hiddenElement.click();
                })
        },
        exportAllTransactions() {
            Api()
                .get("/billingBreakdown/export/" + this.billingSummary.id).then(response => {
                    var hiddenElement = document.createElement('a');
                    hiddenElement.href="data:text/csv;charset=utf-8,"+response.data;
                    // hiddenElement.href = 'data:text/csv;charset=utf-8,' + encodeURI(response.data);
                    hiddenElement.target = '_blank';
                    hiddenElement.download = this.billingSummary.periodEnd + '_transactions.csv';
                    hiddenElement.click();

                    
                })
        },
        exportCustomerTransactions(customerOrganisationId) {
            Api()
                .get("/billingBreakdown/export/customer/" + this.billingSummary.id + '/' + customerOrganisationId).then(response => {
                    var hiddenElement = document.createElement('a');
                    hiddenElement.href = 'data:text/csv;charset=utf-8,' + encodeURI(response.data);
                    hiddenElement.target = '_blank';
                    hiddenElement.download = this.billingSummary.periodEnd + '_transactions.csv';
                    hiddenElement.click();
                })
        },
        exportCustomerChanges(customerOrganisationId) {
            Api()
                .get("/billingBreakdown/export/customer/changes/" + this.billingSummary.id + '/' + customerOrganisationId).then(response => {
                    var hiddenElement = document.createElement('a');
                    hiddenElement.href = 'data:text/csv;charset=utf-8,' + encodeURI(response.data);
                    hiddenElement.target = '_blank';
                    hiddenElement.download = this.billingSummary.periodEnd + '_changes.csv';
                    hiddenElement.click();
                })
        },
        async sageExport(){
            let months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec']
            await Api()
                .get("/billingSummary/purpleForest/" + this.billingSummary.id).then(response => {
                    var hiddenElement = document.createElement('a');
                    hiddenElement.href="data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,"+response.data;
                    hiddenElement.target = '_blank';
                    hiddenElement.download = `Inv_Import_${months[this.billingSummary.month-1]} ${this.billingSummary.year}.xls`;
                    hiddenElement.click();
                })
        },
        approveBilling() {
            this.billingItem = {
                status: 'DRAFT',
                lineAmountType: 'Exclusive',
                createInvoice: true,
                dueDate: this.formatBillingDate(new Date())
            }
            this.approveBillingModal = true
        },
        async submitBilling() {
            this.loadingInvoices = true
            // let invoices = this.invoiceData.filter(x=>x.accountingId)
            let invoices = this.invoices.map(x => ({
                // serviceAccounts: x.accounts,
                id: x.id,
                customerOrganisationId: x.customerOrganisationId,
                type: 'ACCREC',
                contact: {
                    contactID: x.xeroContactId
                },
                lineAmountTypes: 'Exclusive',
                reference: this.billingItem.reference,
                status: this.billingItem.status,
                dueDate: x.dueDate,
                lineItems: x.invoiceLineItems
                .map(y => ({
                    itemCode: y.accountType == 'Item'? y.accountCode:null,
                    accountCode: y.accountType == 'Account'? y.accountCode:null,
                    quantity: y.quantity,
                    description: y.description,
                    taxType: y.taxTypeId,
                    unitAmount: y.amount
                }))
            }))
            invoices = invoices.filter(x=>x.contact && x.contact.contactID)

            await Api().post('/xero/invoices', {
                    // billingData: this.billingBreakdown,
                    invoices: invoices,
                    sendEmail: this.billingItem.sendEmail,
                    billingSummaryId: this.billingSummary.id
                })
                .then(response => {
                    Api()
                    if (response.data.response.statusCode == 200) {
                        this.successfulInvoices = response.data.body.invoices
                        this.invoiceSuccessModal = true
                        this.sendingInvoices = false
                    }
                    this.loadingInvoices = false
                    this.billingItem = {}
                    this.approveBillingModal = false
                    Api().put('/billingSummary/approve/' + this.billingSummary.id).then(() => {
                        this.load()
                    })
                })

        },
        async approveTransactions() {
            Api().put('/billingSummary/approve/' + this.billingSummary.id).then(() => {
                this.billingItem = {}
                this.approveBillingModal = false
                this.load()
            })
        },
        backToSummaryList() {
            this.$router.push({
                path: "/billing"
            });
        },
        async downloadInvestorReport(investor){
            investor.loading = true
            console.log(this.billingSummary)
            await Api().get(`/billingBreakdown/export/investor/${this.billingSummary.id}/${investor.id}`).then(response => {
                var hiddenElement = document.createElement('a');
                hiddenElement.href="data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,"+response.data;
                hiddenElement.target = '_blank';
                hiddenElement.download = investor.name+'_'+this.billingSummary.periodEnd + '.xls';
                hiddenElement.click();
                investor.loading = false
            })
        },
        getInvoiceData(id){
          Api().get('/invoice/isp/'+id).then(res=>{
            this.invoices = res.data
          })
        },
        async getBillingSummary(id) {
            await Api().get('/billingSummary/summary/' + id).then(async res => {
                this.billingSummary = res.data
                this.getBillingBreakdown()
                this.getTransactionSummary(this.billingSummary.batchNumber)
            })
        },
        getIspStatistics(id){
             Api().get('/billingSummary/ispStatistics/' + id).then(async res => {
                 console.log(res.data)
                 this.ispStatistics = res.data
             })
        },  
        transactionDescriptions(transactions) {
            let result = transactions && transactions.length > 0 ? transactions : []
            return [...new Set(result.map(x => x.description))]
        },
        transactionNetworks(transactions) {
            let result = transactions && transactions.length > 0 ? transactions : []
            return [...new Set(result.filter(x => x.locationNetwork).map(x => x.locationNetwork.name))]
        },
        transactionNodes(transactions) {
            let result = transactions && transactions.length > 0 ? transactions : []
            return [...new Set(result.filter(x => x.locationNode).map(x => x.locationNode.name))]
        },
        async getNetworkInsights(id) {
            await Api().get('/organisation/networkBreakdown/' + id).then(async res => {
                this.networkTransactions = res.data
            })
        },
        async getTransactionSummary(batchNumber) {
            await Api().get('/transactions/batch/' + batchNumber).then(res => {
                this.transactionSummary = res.data
            })

        },

        async getBillingBreakdown() {
            await Api().get('/billingSummary/breakdown/' + this.billingSummary.id).then(res => {
                this.billingBreakdown = res.data
                this.ispList = [...new Set(this.billingBreakdown.map(x => x.isp))].sort((a, b) => a.toLowerCase() > b.toLowerCase() ? 1 : -1)
                this.networkList = [...new Set(this.billingBreakdown.map(x => x.network))].sort((a, b) => a.toLowerCase() > b.toLowerCase() ? 1 : -1)
                this.fnoPackageList = [...new Set(this.billingBreakdown.map(x => x.fnoPackage))].sort((a, b) => a.toLowerCase() > b.toLowerCase() ? 1 : -1)
                this.loadCharts()
                this.fetchBillingSettings()
                // this.fetchFnoPackages()
            })
        },
        formatDate(date) {
            if (date !== null) {
                return dateformat(date, "dd/mm/yyyy");
            } else {
                null;
            }
        },
        formatBillingDate(date) {
            if (date !== null) {
                return dateformat(date, "yyyy-mm-dd");
            } else {
                null;
            }
        },
        async fetchXeroAccounts() {
            await Api().get('/xero/accounts').then(res => {
                let result = res.data.body.accounts
                this.accountingAccounts = result.map(x => ({
                    id: x.accountID,
                    code: x.code,
                    name: x.name
                }))
                console.log(this.accountingAccounts)
            })
            await Api().get('/xero/contacts').then(res => {
                this.accountingContacts = res.data.body.contacts
            })
        },
        async fetchXeroItems() {
            await Api().get('/xero/items').then(res => {
                let result = res.data.body.items

                this.accountingItems = result.map(x => ({
                    id: x.itemID,
                    name: x.name
                }))
            })
        },
        async fetchConnectedOrganisations() {
            await Api().get('/organisationConnection').then(async res => {
                this.connectedOrgs = res.data
                await this.fetchXeroContactSettings(this.connectedOrgs.filter(x => x.accountingId))
            })
        },
        async fetchXeroContactSettings(contacts) {
            await Api().post('/xero/contactSettings', contacts).then(res => {
                for (let i = 0; i < res.data.length; i++) {
                    let dueDate = new Date()
                    dueDate.setFullYear(this.billingSummary.year)

                    if (res.data[i].paymentTerms.sales) {
                        if (res.data[i].paymentTerms.sales.type == 'OFFOLLOWINGMONTH') {
                            dueDate.setMonth(this.billingSummary.month)
                            dueDate.setDate(res.data[i].paymentTerms.sales.day)
                        } else if (res.data[i].paymentTerms.sales.type == 'DAYSAFTERBILLMONTH') {
                            dueDate.setMonth(this.billingSummary.month)
                            dueDate.setDate(res.data[i].paymentTerms.sales.day)
                        }
                    }
                    let find = this.connectedOrgs.find(x => x.id == res.data[i].id)
                    let index = this.connectedOrgs.indexOf(find)
                    this.connectedOrgs[index].dueDate = this.formatBillingDate(dueDate)
                }
                console.log(this.connectedOrgs)
            })
        },
        async fetchBillingSettings() {
            await Api().get('/organisation/billingSettings').then(async res => {
                this.billingSettings = res.data
                await this.fetchConnectedOrganisations()
                await this.fetchFnoPackages()
                if (this.billingSettings.accountingId) {
                    await this.fetchXeroAccounts()
                    await this.getXeroTaxRates()
                }

                if (this.billingSummary.status == 'Pending') {
                    // this.compileInvoiceData()
                }
            })
        },
        async fetchFnoPackages() {
            await Api().get('/packagesFnos/all').then(res => {
                this.packagesFno = res.data
            })
        },
        async getXeroTaxRates() {
            await Api().get('/xero/taxRates').then(response => {
                this.taxTypes = response.data.body.taxRates
            })
        },
        CalculatePercentage(start, end) {
            return Math.round(((start - end) / end) * 10000) / 100
        },
        async compileInvoiceData() {
            this.invoiceData = []

            let organisations = [
                ...new Set(
                    this.billingBreakdown.map(
                        item => item.customerOrganisationId
                    )
                )
            ];
            // console.log(organisations)
            for (let x = 0; x < organisations.length; x++) {
                let find = await this.connectedOrgs.find(y => y.connectedOrganisationId === organisations[x])
                if (find) {
                    let obj = {
                        organisationId: organisations[x],
                        name: find.connectedOrganisation.name,
                        dueDate: find.dueDate ? find.dueDate : this.formatBillingDate(new Date()),
                        linkDate: find.dueDate ? false : true,
                        accountingId: find.accountingId,
                        lineItems: [],
                        accounts: await this.billingBreakdown.filter(a =>
                            a.customerOrganisationId == organisations[x]
                        )
                    }
                    let onceOffData = await this.billingBreakdown.filter(z =>
                        z.onceOffFee > 0 && z.customerOrganisationId == organisations[x]
                    )

                    if (this.billingSettings.billIsp) {
                        let installs = await this.fetchInstallsByCustomer(this.billingSummary.periodStart, this.billingSummary.periodEnd, organisations[x])
                        if (installs.length > 0) {
                            await obj.lineItems.push({
                                accountingId: this.billingSettings.installAccountCode,
                                description: 'Installation Fee',
                                taxTypeId: this.billingSettings.taxType,
                                type: 'install',
                                accountType: this.billingSettings.installFeeType,
                                accountName: this.billingSettings.installAccountCode ? this.billingSettings.installFeeType == 'Account' ? this.accountingAccounts.find(a => a.id == this.billingSettings.installAccountCode) : this.accountingItems.find(a => a.id == this.billingSettings.installAccountCode) : null,
                                quantity: this.billingSettings.installFeeType == 'Item' ? installs.length : 1,
                                amount: installs.reduce((a, b) => +a + +b.routerInstallationFee / (1 + $VAT), 0)
                            })
                        }
                    }
                    if (onceOffData.length > 0) {
                        let setupObj = {
                            accountingId: this.billingSettings.setupAccountCode,
                            description: 'Setup Fee',
                            taxTypeId: this.billingSettings.taxType,
                            taxType: null,
                            type: 'setup',
                            accountType: this.billingSettings.setupFeeType,
                            accountName: this.billingSettings.setupAccountCode ? this.billingSettings.setupFeeType == 'Account' ? this.accountingAccounts.find(a => a.id == this.billingSettings.setupAccountCode) : this.accountingItems.find(a => a.id == this.billingSettings.setupAccountCode) : null,
                            quantity: this.billingSettings.setupFeeType == 'Item' ? onceOffData.length : 1,
                            amount: onceOffData.reduce((a, b) => +a + +b.onceOffFee, 0)
                        }

                        let taxRate = this.taxTypes.find(x => x.taxType == this.billingSettings.taxType)
                        if (taxRate) {
                            setupObj.taxType = taxRate.name
                            setupObj.total = ((100 + taxRate.effectiveRate) / 100) * setupObj.amount
                        } else {
                            setupObj.total = setupObj.amount
                        }
                        await obj.lineItems.push(setupObj)
                    }
                    let recurringData = await this.billingBreakdown.filter(z =>
                        z.customerOrganisationId == organisations[x]
                    )
                    if (this.billingSettings.aggregatePackageBilling) {
                        if (recurringData.length > 0) {
                            let packageObj = {
                                accountingId: this.billingSettings.packageAccount,
                                description: 'VAS Sales',
                                taxTypeId: this.billingSettings.taxType,
                                taxType: null,
                                type: 'package',
                                accountType: 'Account',
                                accountName: this.accountingAccounts.find(a => a.id == this.billingSettings.packageAccount),
                                quantity: 1,
                                amount: recurringData.reduce((a, b) => +a + +b.packageFee, 0)
                            }
                            let taxRate = this.taxTypes.find(x => x.taxType == this.billingSettings.taxType)
                            if (taxRate) {
                                packageObj.taxType = taxRate.name
                                packageObj.total = ((100 + taxRate.effectiveRate) / 100) * packageObj.amount
                            } else {
                                packageObj.total = packageObj.amount
                            }
                            await obj.lineItems.push(packageObj)
                        }
                    } else {
                        let uniquePackages = [...new Set(recurringData.map(x => x.packagesFnoId))]
                        if (recurringData.length > 0) {
                            for (let y = 0; y < uniquePackages.length; y++) {
                                let fnoPackage = this.packagesFno.find(z => z.id == uniquePackages[y])
                                // if()
                                let packageObj = {
                                    accountingId: fnoPackage.accountCode,
                                    description: fnoPackage.packageCode,
                                    taxTypeId: this.billingSettings.taxType,
                                    taxType: null,
                                    type: 'package',
                                    accountType: fnoPackage.accountType,
                                    accountName: fnoPackage.accountCode ? fnoPackage.accountType == 'Account' ? this.accountingAccounts.find(a => a.id == fnoPackage.accountCode) : this.accountingItems.find(a => a.id == fnoPackage.accountCode) : null,
                                    quantity: fnoPackage.accountType == 'Item' ? recurringData.filter(x => x.packagesIsp.packagesFnoId === uniquePackages[y]).length : 1,
                                    amount: recurringData.filter(x => x.packagesFnoId === uniquePackages[y]).reduce((a, b) => +a + +b.packageFee, 0)
                                }
                                let taxRate = this.taxTypes.find(x => x.taxType == this.billingSettings.taxType)
                                if (taxRate) {
                                    packageObj.taxType = taxRate.name
                                    packageObj.total = ((100 + taxRate.effectiveRate) / 100) * packageObj.amount
                                } else {
                                    packageObj.total = packageObj.amount
                                }
                                await obj.lineItems.push(packageObj)
                            }
                        }
                    }

                    obj.subTotal = obj.lineItems.reduce((a, b) => +a + +b.amount, 0)

                    obj.total = obj.lineItems.reduce((a, b) => +a + +b.total, 0)
                    obj.tax = obj.total - obj.subTotal

                    // if(obj.accountingId){
                    // obj.dueDate = this.accountingContacts.find(x=>x.contactID==obj.accountingId)
                    // }
                    await this.invoiceData.push(obj)
                } else {
                    console.log('Cannot find', organisations[x])
                }
            }
            this.loadingInvoiceData = false
        },
        async fetchInstallsByCustomer(start, end, organisationId) {
            let result = []
            await Api().get('/applications/installs/' + organisationId, {
                params: {
                    start: start,
                    end: end
                }
            }).then(res => {
                result = res.data
            })
            return result
        },

        updateLinkedItems() {
            this.invoiceData.map(x => {
                if (x.linkDate) {
                    x.dueDate = this.billingItem.dueDate
                }
                return x
            })
            // for(let i=0;i<data.length;i++){
            //   data[i].dueDate = value
            // }
            console.log(this.invoiceData)
        },
        async loadCharts() {
            var ispListArray = this.ispList
            ispListArray = ispListArray.map(x => ({
                isp: x,
                sales: this.billingBreakdown.filter(y => y.isp == x).reduce(
                    (a, b) => +a + +b.packageFee,
                    0
                )
            }))
            ispListArray.sort((a, b) => a.sales < b.sales ? 1 : -1)
            this.ispSalesData = {
                labels: ispListArray.map(x => x.isp),
                datasets: [{
                    label: "Sales",
                    data: ispListArray.map(x => x.sales),
                    backgroundColor: this.pSBC(0.35, '#08a31f'),
                    borderColor: '#08a31f',
                    borderWidth: 1
                }]
            }
            this.ispSalesOptions = {
                title: {
                    display: true,
                    text: "Sales by ISP"
                }
            }

            var uniqueDownload = [...new Set(this.billingBreakdown.map(x => x.downloadMbps))].sort((a, b) => a > b ? 1 : -1)
            var downloadCounts = []
            var colors = []
            for (let i = 0; i < uniqueDownload.length; i++) {
                downloadCounts.push(this.billingBreakdown.filter(x => x.downloadMbps == uniqueDownload[i]).length)
                let find = this.billingBreakdown.find(x => x.downloadMbps == uniqueDownload[i])
                colors.push(find.speedProfile.colour)
                uniqueDownload[i] = uniqueDownload[i] + 'Mbps'
            }

            // uniqueDownload.map(x=>{x = x+'Mbps'})

            this.speedData = {
                labels: uniqueDownload,
                datasets: [{
                    label: "Speed",
                    data: downloadCounts,
                    backgroundColor: colors.map(x => this.pSBC(0.35, x)),
                    borderColor: colors,
                    borderWidth: 1
                }]
            }
            this.speedDataOptions = {
                title: {
                    display: true,
                    text: "Packages Sales by Speed"
                },
                //   tooltip: {
                //     enabled: true
                //   },
                tooltips: {
                    callbacks: {
                        title: function (tooltipItem, data) {
                            return data['labels'][tooltipItem[0]['index']];
                        },
                        label: function (tooltipItem, data) {
                            return Number(data['datasets'][0]['data'][tooltipItem['index']]).toFixed(0).replace(/./g, function (c, i, a) {
                                return i > 0 && c !== "." && (a.length - i) % 3 === 0 ?
                                    "," + c :
                                    c;
                            });
                        },
                        afterLabel: function (tooltipItem, data) {
                            var dataset = (data['datasets'][0]);
                            // console.log(dataset["_meta"])
                            try {
                                var percent = Math.round((dataset['data'][tooltipItem['index']] / dataset["_meta"][0]['total']) * 100)
                                return '(' + percent + '%)';
                            } catch (e) {
                                return
                            }

                        }
                    }
                },
            }

            var uniqueSpeeds = [...new Set(this.billingBreakdown.map(x => x.speedProfileId))]
            var speeds = []
            for (let i = 0; i < uniqueSpeeds.length; i++) {
                let speed = this.billingBreakdown.find(x => x.speedProfileId === uniqueSpeeds[i]).speedProfile
                speeds.push(speed)
            }
            speeds = speeds.map(x => ({
                speedProfileId: x.id,
                label: x.name,
                colour: x.colour,
                backgroundColor: this.pSBC(0.35, x.colour),
                borderColor: x.colour,
                borderWidth: 1,
                data: []
            }))

            let networksTest = [...new Set(this.billingBreakdown.map(x => x.network))].sort((a, b) => a > b ? 1 : -1)
            for (let b = 0; b < networksTest.length; b++) {
                for (let c = 0; c < speeds.length; c++) {
                    let count = await this.billingBreakdown.filter(d => d.network === networksTest[b] &&
                        d.speedProfileId === speeds[c].speedProfileId).reduce((a, b) => +a + +b.packageFee, 0)
                    await speeds[c].data.push(count)
                }
            }
            (this.networkData = {
                labels: networksTest,
                datasets: speeds
            }),
            (this.networkDataOptions = {
                title: {
                    display: true,
                    text: "Sales by Network"
                },
                responsive: true,
                maintainAspectRatio: false,
                scales: {
                    xAxes: [{
                        stacked: true,
                        categoryPercentage: 0.8,
                        barPercentage: 1
                    }],
                    yAxes: [{
                        stacked: true,
                        ticks: {
                            beginAtZero: true,
                            callback: function (value) {
                                if (parseInt(value) >= 1000) {
                                    return (
                                        "R" +
                                        value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                                    );
                                } else {
                                    return "R" + value;
                                }
                            }
                        }
                    }]
                },
                tooltips: {
                    callbacks: {
                        label: function (tooltipItem, data) {
                            return (
                                "R" +
                                Number(tooltipItem.yLabel)
                                .toFixed(0)
                                .replace(/./g, function (c, i, a) {
                                    return i > 0 && c !== "." && (a.length - i) % 3 === 0 ?
                                        "," + c :
                                        c;
                                })
                            );
                        }
                    }
                }
            });
            this.loaded = true
        },
        viewTransactionSummary(summary) {
            this.selectedTransactionSummary = summary
            this.transactionSummaryModal = true
        },
        pSBC(p, c0, c1, l) {
            let r,
                g,
                b,
                P,
                f,
                t,
                h,
                i = parseInt,
                m = Math.round,
                a = typeof c1 == "string";
            if (
                typeof p != "number" ||
                p < -1 ||
                p > 1 ||
                typeof c0 != "string" ||
                (c0[0] != "r" && c0[0] != "#") ||
                (c1 && !a)
            )
                return null;
            if (!this.pSBCr)
                this.pSBCr = d => {
                    let n = d.length,
                        x = {};
                    if (n > 9) {
                        ([r, g, b, a] = d = d.split(",")), (n = d.length);
                        if (n < 3 || n > 4) return null;
                        (x.r = i(r[3] == "a" ? r.slice(5) : r.slice(4))),
                        (x.g = i(g)),
                        (x.b = i(b)),
                        (x.a = a ? parseFloat(a) : -1);
                    } else {
                        if (n == 8 || n == 6 || n < 4) return null;
                        if (n < 6)
                            d =
                            "#" +
                            d[1] +
                            d[1] +
                            d[2] +
                            d[2] +
                            d[3] +
                            d[3] +
                            (n > 4 ? d[4] + d[4] : "");
                        d = i(d.slice(1), 16);
                        if (n == 9 || n == 5)
                            (x.r = (d >> 24) & 255),
                            (x.g = (d >> 16) & 255),
                            (x.b = (d >> 8) & 255),
                            (x.a = m((d & 255) / 0.255) / 1000);
                        else
                            (x.r = d >> 16),
                            (x.g = (d >> 8) & 255),
                            (x.b = d & 255),
                            (x.a = -1);
                    }
                    return x;
                };
            (h = c0.length > 9),
            (h = a ? (c1.length > 9 ? true : c1 == "c" ? !h : false) : h),
            (f = this.pSBCr(c0)),
            (P = p < 0),
            (t =
                c1 && c1 != "c" ?
                this.pSBCr(c1) :
                P ?
                {
                    r: 0,
                    g: 0,
                    b: 0,
                    a: -1
                } :
                {
                    r: 255,
                    g: 255,
                    b: 255,
                    a: -1
                }),
            (p = P ? p * -1 : p),
            (P = 1 - p);
            if (!f || !t) return null;
            if (l)
                (r = m(P * f.r + p * t.r)),
                (g = m(P * f.g + p * t.g)),
                (b = m(P * f.b + p * t.b));
            else
                (r = m((P * f.r ** 2 + p * t.r ** 2) ** 0.5)),
                (g = m((P * f.g ** 2 + p * t.g ** 2) ** 0.5)),
                (b = m((P * f.b ** 2 + p * t.b ** 2) ** 0.5));
            (a = f.a),
            (t = t.a),
            (f = a >= 0 || t >= 0),
            (a = f ? (a < 0 ? t : t < 0 ? a : a * P + t * p) : 0);
            if (h)
                return (
                    "rgb" +
                    (f ? "a(" : "(") +
                    r +
                    "," +
                    g +
                    "," +
                    b +
                    (f ? "," + m(a * 1000) / 1000 : "") +
                    ")"
                );
            else
                return (
                    "#" +
                    (
                        4294967296 +
                        r * 16777216 +
                        g * 65536 +
                        b * 256 +
                        (f ? m(a * 255) : 0)
                    )
                    .toString(16)
                    .slice(1, f ? undefined : -2)
                );
        }
    }
}
</script>
